/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import 'bootstrap/dist/css/bootstrap.css';
import './style.scss';
import logo from './img/logo.png';
import LoginForm from './loginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.title = 'Vero Login';
  }

  render() {
    const { translate } = this.props;
    return (
      <div className="container-fluid vero-login">
        <Helmet>
          <link rel="icon" type="image/png" href={logo} sizes="16x16" />
        </Helmet>
        <div className="d-flex flex-row justify-content-center">
          <div className="container">
            <div className="row">
              <div className="col"></div>
              <div className="col login-content">
                <div className='login-logo'>
                  <img
                    className="logo-vero"
                    src={logo}
                    alt="palyhub"
                    width="213"
                    height="43"
                  />
                </div>
                {
                  this._validateParams()
                    ? <LoginForm
                      api={this.api}
                      location={this.props.location}
                    />
                    : <RequestLoginErrorMessage
                      onlyMessage={true}
                      message={translate('RequestLoginErrorMessage')}
                    />
                }
              </div>
              <div className="col"></div>
            </div>

          </div>
        </div>
      </div>
    )

  }
}

export default WithLocalize(Login);
